{"browse_shop":"Mag-browse sa Shop","go_to_shop":"Pumunta sa Shop","no_orders_found":"Walang nahanap na order","title":"Mga Order"}